/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 15/03/2023.
 */

import React, { useEffect, useState } from 'react'

import { InputNumber, Select, Space } from 'antd'
import { UseFormReturn } from 'react-hook-form'
import { FormLabel } from './FormLabel'
import { COUNTRY_TYPE, CRUD_VIEW_TYPE } from '../../Types'

const { Option } = Select

type Props = { formHook: UseFormReturn; data: any; viewType: CRUD_VIEW_TYPE; supportedCountries: COUNTRY_TYPE[] }

const countryKey = 'countryCode'
const telKey = 'tel'

export const FormPhoneNumber = ({ data, formHook, viewType, supportedCountries }: Props) => {
  const {
    setValue,
    register,
    formState: { errors },
    clearErrors,
    getValues,
  } = formHook

  const formValue = getValues(data.id)
  const currentValue = !formValue ? data.value : formValue
  const valueFromBackend = currentValue

  const [countryCodeState, setCountryCodeState] = useState<any>(
    valueFromBackend[countryKey] ? valueFromBackend[countryKey] : ''
  )
  const [telState, setTelState] = useState<any>(valueFromBackend[telKey] ? valueFromBackend[telKey] : '')

  const onSelect = (v, k) => {
    clearErrors(countryCodeState)
    setCountryCodeState(k.value)
    // console.log('FormPhoneNumber > onSelect > ', v, k.value, data.id, telState)
    setValue(data.id, { [countryKey]: k.value, [telKey]: telState })
  }

  const numberChange = (k: string | null) => {
    if (k && k.length !== 0) {
      clearErrors(telState)
    }

    console.log('FormPhoneNumber > k = ', k)
    if (k !== null) {
      const num = parseInt(k)

      setTelState(num)
      setValue(data.id, { [countryKey]: countryCodeState, [telKey]: num })
    } else {
      setTelState('')
      setValue(data.id, { [countryKey]: countryCodeState, [telKey]: '' })
    }
  }

  useEffect(() => {
    register(data.id, data.validation)

    //if (data.value) {
    setValue(data.id, valueFromBackend ? valueFromBackend : { [countryKey]: '', [telKey]: '' })
    //}

    //setValue(data.id, valueFromBackend ? valueFromBackend : { [countryKey]: '', [telKey]: '' })
  }, [register, data.id, data.validation, setValue, data.value, valueFromBackend])

  const errorState = errors[data.id]
  const countryErrorState = errors[countryKey]

  const errorMessage = errorState && errorState.message ? errorState.message : data.errorMsg
  const countryErrorMessage: any =
    countryErrorState && countryErrorState.message ? countryErrorState.message : 'Missing country code'

  //Don't need setState since you're not allowed to change the phone number
  const [state] = useState<string | any>(currentValue)

  const selectBefore = (
    <Select
      defaultValue={state ? state.countryCode : ''}
      optionLabelProp="label"
      onSelect={onSelect}
      popupMatchSelectWidth={400}
      style={{ width: 95 }}
    >
      {supportedCountries.map((item, index) => {
        return (
          <Option key={index} value={item.countryCode}>
            <p>
              {item.countryCode} <span className="opacity-75">{item.name}</span>
            </p>
          </Option>
        )
      })}
    </Select>
  )

  return (
    <div className="py-2">
      <FormLabel label={data.label}>
        {data.postfix ? (
          <p>
            {data.label} <span className="opacity-75 p-small">{data.postfix}</span>
          </p>
        ) : null}
      </FormLabel>
      <Space.Compact className="w-100">
        {selectBefore}
        <InputNumber className="w-100" onChange={numberChange} defaultValue={state ? state.tel : ''} />
      </Space.Compact>

      {errorState ? <div className="p-small text-danger">{errorMessage}</div> : null}
      {countryErrorState ? <div className="p-small text-danger">{countryErrorMessage}</div> : null}
    </div>
  )
}
